import React, { useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MobileSecViewsHeader from "../../components/MobileSecViewsHeader";
import NewUserForm from "../../components/NewUserForm";
import { User } from "../../api/models/user-model";
import { CircularProgress } from "@mui/material";
import api from "../../api";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";
import { showError } from "../../utils/helpers";

const MobileEditUser = () => {
  const navigate = useNavigate();
  const labels = useAppSelector(selectLabels);
  const dispatch = useAppDispatch();

  const { id: selectedUserId, user_role: selectedUserRole } = useParams<{
    id: string;
    user_role: string;
  }>();

  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const roleId =
    selectedUserRole === "property_admin"
      ? 6
      : selectedUserRole === "security_guard"
      ? 4
      : 3;

  const getUser = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await api.userByIdRequestTwo(Number(selectedUserId));
      setUser(response);
    } catch (error: any) {
      console.error(error);
      const errorMessage = error?.response?.data?.error?.message;
      showError(dispatch, errorMessage ? errorMessage : labels.generic_error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, labels.generic_error, selectedUserId]);

  React.useEffect(() => {
    getUser();
  }, [getUser]);

  return (
    <div className="w-100 h-100 border-box p-8 scroll">
      <div className="mb-4">
        <MobileSecViewsHeader title={labels.edit_user} route={"/users"} />
      </div>
      {isLoading ? (
        <div className="w-100 h-100 flex justify-content-center align-items-center">
          <CircularProgress />
        </div>
      ) : (
        <NewUserForm
          roleToCreate={roleId}
          showForm={false}
          setShowForm={() => {}}
          extraFunc={() => navigate("/users")}
          isMobile={true}
          selectedUser={user}
        />
      )}
    </div>
  );
};

export default MobileEditUser;
